// ----------------------------------------------------------------------
// <copyright file="Izenda.VizEngine.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * A visualizaiton engine base class
 */
import { exportClass } from 'share/Izenda.ServiceProvider';

@exportClass('VizEngine')
export default class VizEngine {
  /**
   * Draw visualization into container and return instance with releasing function
   * @param {DOMElement} chartContainer DOM element of virtualization
   * @param {string} chartType Chart type
   * @param {Object} options Chart options
   * @param {Function} onCompleted A callback function to be invoked after finished rendering
   */
  draw(chartContainer, chartType, options, onCompleted) {}

  /**
   * Log highchart options for troubleshooting purpose
   * @param {Object} options Highchart options
   */
  logHighchartOptions(options) {
    if (!console) {
      return;
    }

    let cache = [];
    const jsonOptions = JSON.stringify(options, function(key, value) {
      if (typeof value === 'object' && value !== null) {
        if (cache.indexOf(value) !== -1) {
          // Circular reference found, discard key
          return;
        }
        // Store value in our collection
        cache.push(value);
      }
      // Ignore chartContainer or background map object as it just contains the reference data
      return key === 'chartContainer' || key === 'backgroundMap' || key === 'mapData' ? null : value;
    });
    cache = null;
  }
}



// WEBPACK FOOTER //
// ./ui/share/components/charting/Izenda.VizEngine.js